
import app from '../App';

export default class PricingController {

    constructor ( $scope, $location, $route, $routeParams, Info , PlansService) {

        'ngInject';
        $scope.message = Info.welcomeMessage;
        $scope.pricingParams={};
        $scope.pricingParams.plan=$routeParams.plan?$routeParams.plan:'annual';
        $scope.pricingParams.displays=$routeParams.displays?parseInt($routeParams.displays):1;
        $scope.pricingParams.devices=$routeParams.devices?parseInt($routeParams.devices):1;
        $route.updateParams($scope.pricingParams);
        $scope.show404 = function () {
        	$location.path('/test-404');
        };
        // $scope.$watch('pricingParams', function(newValue, oldValue) {
        //     $route.updateParams($scope.pricingParams);
        // });
    }

};

app.controller( 'PricingController', PricingController );



// WEBPACK FOOTER //
// ./src/js/controllers/PricingController.js